/**
 * Checks if at least one of the user's roles is allowed
 * @param {string[]} [allowedRoles=[]] - Roles that are allowed to perform the action
 * @param {string[]} [currentAccountRoles=[]] - Roles the current user possesses
 * @returns {boolean} - True if at least one allowed role is present in current roles, or no roles are required
 */
export const isRoleAllowed = (
  allowedRoles = [],
  currentAccountRoles = []
) => {
  if (!allowedRoles || allowedRoles?.length === 0) {
    return true;
  }

  return allowedRoles.some((role) => currentAccountRoles.includes(role));
};
